import { useEffect, useState } from "react";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

import LocalTable from "../../../components/locais/table";
import { VerticalContainer } from "../../../components/styled";
import history from "../../../routes/history";
import { getLocalViagens } from "../../../services/locais";
import { deleteMotorista } from "../../../services/motoristas";

const { Search } = Input;

export default function ListLocais() {
  const [filter, setFilter] = useState("");
  const [locais, setLocais] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const getLocaisPaginated = async () => {
    setLoading(true);
    try {
      const locaisGet = await getLocalViagens(page, filter);
      setLocais(locaisGet);
      setTotal(locaisGet.length);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getLocaisPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };
  async function confirm(record) {
    await deleteMotorista(record.id);
    await getLocaisPaginated();
  }

  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter("");
  };

  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: "50%" }}
          placeholder="Pesquisar locais..."
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            history.push("/adicionar-local");
          }}
          style={{ width: "100%!important" }}
          block
        >
          <PlusOutlined />
          Adicionar locais de embarque/desembarque
        </Button>
        <br />
        <LocalTable
          loading={loading}
          handleTableChange={handleTableChange}
          locais={locais}
          total={total}
          confirm={confirm}
        />
      </VerticalContainer>
    </>
  );
}
